// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3HbLl","productName":"Table_productName__2Iux3"};